export type ApiTestimonial = {
  id: string;
  name: string;
  city: string;
  photoUrl: string | null;
  rating: number;
  quote: string;
  featured: number;
  createdAt: string;
};

export const TESTIMONIALS_FALLBACK: ApiTestimonial[] = [
  {
    id: "fallback-buyer",
    name: "Priya Sharma",
    city: "Mumbai",
    photoUrl: "/assets/images/Indian_female_professional_67f01c9b.png",
    rating: 5,
    quote:
      "PropGauge gave me a valuation that was within 2% of what we eventually closed at.",
    featured: 1,
    createdAt: "",
  },
  {
    id: "fallback-seller",
    name: "Rajesh Kumar",
    city: "Bangalore",
    photoUrl: "/assets/images/Indian_businessman_testimonial_09880669.png",
    rating: 5,
    quote:
      "I sold my 3BHK in Whitefield using RealtyBlocks' valuation report as my anchor price.",
    featured: 1,
    createdAt: "",
  },
  {
    id: "fallback-service",
    name: "Amit Patel",
    city: "Delhi",
    photoUrl: "/assets/images/Indian_interior_designer_44bc6c5a.png",
    rating: 5,
    quote:
      "I refer all my clients here before they buy. Locality-level price-per-sqft trends are accurate.",
    featured: 1,
    createdAt: "",
  },
  {
    id: "fallback-nri",
    name: "Sneha Iyer",
    city: "Pune",
    photoUrl: null,
    rating: 5,
    quote:
      "I'm an NRI based in Singapore and was nervous about buying in Pune sight-unseen. The AI report gave me real confidence.",
    featured: 1,
    createdAt: "",
  },
  {
    id: "fallback-fast",
    name: "Vikram Singh",
    city: "Gurugram",
    photoUrl: null,
    rating: 5,
    quote:
      "Clean, fast, and free. Got my valuation in under a minute and the rental yield estimate matched what my tenant pays today.",
    featured: 1,
    createdAt: "",
  },
  {
    id: "fallback-whatsapp",
    name: "Ananya Desai",
    city: "Hyderabad",
    photoUrl: null,
    rating: 4,
    quote:
      "Loved the WhatsApp follow-up — actual human replies, no spam. Valuation was close to what I was quoted offline.",
    featured: 1,
    createdAt: "",
  },
];
